import { PROJECT_ID } from "config/keys/user";
import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";

const app = getApp(PROJECT_ID);
// =============================== BASE  ===============================  //

export const REF = {
  NAME: "(default)",
  COLLECTIONS: {
    USER: "user",
    CLIENT: "client",
    RESELLER: "reseller",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    user: collection(firestore, REF.COLLECTIONS.USER),
    client: collection(firestore, REF.COLLECTIONS.CLIENT),
    reseller: collection(firestore, REF.COLLECTIONS.RESELLER),
  };
  return CREF;
};
